import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  AutoComplete,
  Button,
  Spinner,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";

import Notiflix from "notiflix";
import GetApiCall from "../../Api/GetApi";
import PostApiCall from "../../Api/Api";
import BreadCrumb from "../../Components/BreadCrumbComp";
import maleIcon from "../../assets/profile/user.jpeg";
import { XSquare } from "react-feather";
import { ImageApiUrl, PdfApiUrl } from "../../Helper/Additional";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import moment from "moment";
import {
  addressProof,
  Allqualification,
  fileConverterHandler,
  gender,
  generatePassword,
  idProof,
  imageConverterHandler,
  usertype,
  validationSchema,
} from "./helper";
import { generateCustomStyles } from "../../Helper/CustomStyleError";
const AuditorJobPage = () => {
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const history = useHistory();

  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [imagefile, setImageFile] = useState("");

  const formik = useFormik({
    initialValues: {
      AuditorName: "",
      AuditorAge: "",
      AuditorContact: "",
      AuditorGmail: "",
      AuditorAddress: "",
      AuditorCity: "",
      AuditorCountry: { value: 101, label: "India" },
      AuditorState: "",
      AuditorPincode: "",
      AuditorQual: "",
      TotalExperience: "",
      ExperienceTrpw: 0,
      WorkExperience: "",
      IDProof: "Pancard",
      IdProofNumber: "",
      AddressProof: "",
      AddressProofNumber: "",
      identityProofFile: "",

      qualProofFile: "",
      AddressProofFile: "",
      PanHolderName: "",
      resume: "",
      gender: "",
      usertype: { value: "Seeker", label: "Seeker" },
      resumeFile: "",
      SourceName: "",
      WorkCity: [],
      PreEmployeeName: "",
    },
    validationSchema: validationSchema,
    validateOnChange: true,

    onSubmit: async (values, { resetForm }) => {
      try {
        Notiflix.Loading.standard();

        const UserRegister = {
          name: formik.values.AuditorName,
          mobile: formik.values.AuditorContact,
          email: formik.values.AuditorGmail,
          password: generatePassword(12),
          usertype: formik.values.usertype.value,
          updatedon: moment().format("ll"),
          addedon: moment().format("ll"),
          emailverify: "No",
        };

        const payload = {
          employeeid: "JEA",
          photo: imagePreviewUrl.replace(
            process.env.REACT_APP_FILE_S3_PATH_URL,
            ""
          ), // Replace with actual binary data for the photo
          dob: formik.values.AuditorAge,
          gender: formik.values.gender.value,
          presentaddress: formik.values.AuditorAddress,
          presentcountry: formik.values.AuditorCountry.label,
          presentstate: formik.values.AuditorState.label,
          presentcity: formik.values.AuditorCity.label,
          presentpincode: formik.values.AuditorPincode,
          permanentaddress: "456 Park St",
          permanentcountry: "Country2",
          permanentstate: "State2",
          permanentcity: "City2",
          permanentpincode: "67890",
          qualification: formik.values.AuditorQual.value,
          experience: formik.values.TotalExperience || 0,
          expowncompany: formik.values.ExperienceTrpw || 0,
          prevcompname: formik.values.PreEmployeeName || "",
          worksummary: formik.values.WorkExperience,
          identityproofname: formik.values.PanHolderName || "",
          identityprooftype: "Pancard",
          identityproofnumber: formik.values.IdProofNumber,
          addressprooftype: formik.values.AddressProof.value,
          addressproofnumber: formik.values.AddressProofNumber,
          sourcename: formik.values.SourceName || "",
          verifyaccount: 1,
          fld_verifydoc: 1,
          verifyemp:0
        };
        let cityArr = await formik.values.WorkCity.map((ele) =>
          ele.value.trim()
        ).join(",");
        payload.workcity = cityArr;


        const registerCandidateResult = await PostApiCall.postRequest(
          UserRegister,
          "RegisterCandidate"
        );

        if (registerCandidateResult.status === 200) {
          // Make AddJobAuditor API call

          const response = await registerCandidateResult.json();

          const identityProofPromise = fileConverterHandler(
            formik.values.identityProofFile,
            response.data[0].UserId,
            "Identity"
          );
          const addressProofPromise = fileConverterHandler(
            formik.values.AddressProofFile,
            response.data[0].UserId,
            "Address"
          );

          const qualProofPromise = fileConverterHandler(
            formik.values.qualProofFile,
            response.data[0].UserId,
            "Qualification"
          );

          const resumePromise = fileConverterHandler(
            formik.values.resumeFile,
            response.data[0].UserId,
            "Resume"
          );

          // Wait for all file conversions to complete
          const [identityProofUrl, addressProofUrl, qualProofFile, resumeUrl] =
            await Promise.allSettled([
              identityProofPromise,
              addressProofPromise,
              qualProofPromise,
              resumePromise,
            ]);

          payload.identityproofurl = identityProofUrl.value;
          payload.qualificationproofurl = qualProofFile.value;
          payload.addressproofurl = addressProofUrl.value;
          payload.resumeurl = resumeUrl.value;
          payload.userid = response.data[0].UserId;
          const addJobAuditorResult = await PostApiCall.postRequest(
            payload,
            "AddJobAuditor"
          );

          if (
            addJobAuditorResult.status === 200 ||
            addJobAuditorResult.status === 201
          ) {
            // Success
            Notiflix.Loading.remove();
            toast.success("Auditor Added Successfully", { autoClose: delay });
            history.push("/auditor-list");
          } else {
            // Handle AddJobAuditor API call error
            const errorMessage = await addJobAuditorResult.json();
            Notiflix.Loading.remove();
            toast.error(errorMessage.error, { autoClose: delay, toastId: 1 });
          }
        } else {
          // Handle RegisterCandidate API call error
          const errorMessage = await registerCandidateResult.json();
          Notiflix.Loading.remove();
          toast.error(errorMessage.error, { autoClose: delay, toastId: 1 });
        }
      } catch (error) {
        // Handle general error
        toast.error(SomethingWrong, { autoClose: delay, toastId: 1 });
        Notiflix.Loading.remove();
      }
    },
  });

  const submitHandler = async () => {
    window.scrollTo(0, 0);
    formik.handleSubmit();
  };
  const imageConverterHandler = async (newFile) => {
    const form = new FormData();

    form.append("file", newFile);
    form.append("foldername", "Job/Auditor");
    form.append("filename", `photo-${new Date()}`);

    fetch(ImageApiUrl, {
      method: "POST",
      body: form,
    })
      .then((res) => res.json())
      .then((result) => {
        setImagePreviewUrl(result?.Message);
        return result?.Message;
      });
  };
  useEffect(() => {
    Notiflix.Loading.standard();
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);
          Notiflix.Loading.remove();
        })
      );
    };
    getCountry();
  }, []);
  useEffect(() => {
    const getState = () => {
      PostApiCall.postRequest(
        { countryid: formik.values.AuditorCountry?.value },
        "GetState"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllState(obj?.data);
          formik.setFieldValue("AuditorState", obj?.data[0]);
          // Notiflix.Loading.remove()
        })
      );
    };
    getState();
  }, [formik.values.AuditorCountry]);
  useEffect(() => {
    const getCity = () => {
      PostApiCall.postRequest(
        { stateid: formik.values.AuditorState.value },
        "GetCity"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCity(obj?.data);
          formik.setFieldValue("AuditorCity", obj?.data[0]);
          // Notiflix.Loading.remove()
        })
      );
    };
    getCity();
  }, [formik.values.AuditorState]);

  const handleFileChange = (e) => {
    e.preventDefault();

    if (e.target.files[0].size < 500000) {
      const reader = new FileReader();
      const newFile = e.target.files[0];

      reader.onloadend = () => {
        setImageFile(newFile);
        setImagePreviewUrl(reader.result);
        imageConverterHandler(newFile);
      };

      reader.readAsDataURL(newFile);
    } else {
      // Handle file too large
      Notiflix.Notify.failure("File too large, upload file less than 500 kb.");
    }
  };

  const handleRemoveImage = () => {
    setImageFile("");
    setImagePreviewUrl("");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 17);

  return (
    <div className="App mt-5 ">
      <section id="" className="section  px-md-5">
        <div className="container">
          <BreadCrumb icon={false} subitem={"Add Auditor"} />

          <div className="auditorApp mx-3">
            <div className="row">
              <FormGroup className="" style={{ marginTop: "0px" }}>
                {/* <h2>Auditor Form</h2> */}
                <Card
                  id="jobCard "
                  className="border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="headingStyle my-3 ml-4">Basic Information</p>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm={"12"}>
                          <div className="d-flex flex-wrap align-items-center">
                            <div className="avatar avatar-xl mb-4 ">
                              <img
                                src={
                                  imagePreviewUrl ? imagePreviewUrl : maleIcon
                                }
                                alt="User Image"
                                width={"100%"}
                                height={"100%"}
                                className="shadow"
                              />
                            </div>
                            <div className="mb-4">
                              <p className="ml-2">
                                (Only *.jpeg and *.png images will be accepted)
                              </p>

                              <label
                                htmlFor="imgUpload"
                                color="primary"
                                outline={true}
                                className="btn-border ml-2 mt-3 px-2"
                              >
                                Upload Profile Image
                              </label>
                              <input
                                style={{ display: "none" }}
                                type="file"
                                accept="image/*"
                                id="imgUpload"
                                onChange={handleFileChange}
                                capture
                              />

                              {imagePreviewUrl && (
                                <XSquare
                                  size={30}
                                  className="text-danger"
                                  onClick={handleRemoveImage}
                                />
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Full Name<span className="mandatory">*</span>
                            </Label>
                            <Input
                              type="text"
                              name="AuditorName"
                              id="nameVertical"
                              placeholder="Enter your Name"
                              style={{ textTransform: "capitalize" }}
                              onChange={formik.handleChange}
                              value={formik.values.AuditorName}
                              invalid={
                                formik.touched.AuditorName &&
                                !!formik.errors.AuditorName
                              }
                            />
                            {formik.touched.AuditorName &&
                              formik.errors.AuditorName && (
                                <FormFeedback>
                                  {formik.errors.AuditorName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Email Address<span className="mandatory">*</span>
                            </Label>
                            <Input
                              type="text"
                              name="AuditorGmail"
                              id="nameVertical"
                              placeholder="Enter your Email"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorGmail.toLocaleLowerCase()}
                              invalid={
                                formik.touched.AuditorGmail &&
                                !!formik.errors.AuditorGmail
                              }
                            />
                            {formik.touched.AuditorGmail &&
                              formik.errors.AuditorGmail && (
                                <FormFeedback>
                                  {formik.errors.AuditorGmail}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="">
                              Contact Number<span className="mandatory">*</span>
                            </Label>

                            <Input
                              type="text"
                              name="AuditorContact"
                              id="nameVertical"
                              placeholder="Enter your Contact"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorContact}
                              onBlur={formik.handleChange}
                              maxLength={10}
                              invalid={
                                formik.touched.AuditorContact &&
                                !!formik.errors.AuditorContact
                              }
                              className="input-no-spinner"
                            />
                            {formik.touched.AuditorContact &&
                              formik.errors.AuditorContact && (
                                <FormFeedback>
                                  {formik.errors.AuditorContact}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label htmlFor="">
                              Gender<span className="mandatory">*</span>
                            </Label>
                            <Select
                              classNamePrefix="select"
                              className={`React ${
                                formik.touched.gender && formik.errors.gender
                                  ? "is-invalid"
                                  : ""
                              }`}
                              name="gender"
                              onChange={(selectedOption) => {
                                formik.setFieldValue("gender", selectedOption);
                              }}
                              options={gender}
                              value={formik.values.gender}
                              styles={generateCustomStyles("gender", formik)}
                            />
                            {formik.touched.gender && formik.errors.gender && (
                              <FormFeedback>
                                {formik.errors.gender.value}
                              </FormFeedback>
                            )}
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Date of Birth <span className="mandatory">*</span>
                            </Label>

                            <Flatpickr
                              className="form-control"
                              // value={activeUpto}
                              placeholder="DD-MM-YYYY"
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                                maxDate: maxDate, // Maximum date is 15 years ago from today
                              }}
                              name="AuditorAge"
                              value={formik.values.AuditorAge}
                              onChange={(dates) => {
                                if (dates?.[0]) {
                                  const formattedDate = moment(dates[0]).format(
                                    "YYYY-MM-DD"
                                  );
                                  formik.setFieldValue(
                                    "AuditorAge",
                                    formattedDate
                                  );
                                } else {
                                  formik.setFieldValue("AuditorAge", ""); // Handle case when date is cleared
                                }
                              }}
                              // onChange={(dates) => {
                              //   // setAuditorAge(dates[0].toISOString().split('T')[0]);
                              //   formik.setFieldValue(
                              //     "AuditorAge",
                              //     dates[0].toISOString().split("T")[0]
                              //   ); // Update formik value
                              // }}
                            />
                            {formik.touched.AuditorAge &&
                              formik.errors.AuditorAge && (
                                <FormFeedback>
                                  {formik.errors.AuditorAge}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        {/* <Col sm="6">
                        <FormGroup>
                          <Label htmlFor="nameVertical">
                            User Type<span className="mandatory">*</span>
                          </Label>
                          <Select
                            className={`React ${
                              formik.touched.usertype && formik.errors.usertype
                                ? "is-invalid"
                                : ""
                            }`}
                            classNamePrefix="select"
                            name="usertype"
                            onChange={(selectedOption) => {
                              formik.setFieldValue("usertype", selectedOption);
                            }}
                            options={usertype}
                            value={formik.values.usertype}
                            styles={generateCustomStyles("usertype", formik)}
                          />
                          {formik.touched.usertype &&
                            formik.errors.usertype && (
                              <FormFeedback>
                                {formik.errors.usertype.value}
                              </FormFeedback>
                            )}
                        </FormGroup>
                      </Col> */}
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Preference Cities{" "}
                              <span className="mandatory">*</span>
                            </Label>
                            <CreatableSelect
                              isClearable
                              className={`React ${
                                formik.touched.WorkCity &&
                                formik.errors.WorkCity
                                  ? "is-invalid"
                                  : ""
                              }`}
                              classNamePrefix="Select.."
                              name="WorkCity"
                              isMulti
                              placeholder="Select.."
                              noOptionsMessage={() =>
                                "Type to create new city name"
                              }
                              onChange={(selectedOption) =>
                                formik.setFieldValue("WorkCity", selectedOption)
                              }
                              value={formik.values.WorkCity}
                              styles={generateCustomStyles("WorkCity", formik)}
                            />
                            {formik.touched.WorkCity &&
                              formik.errors.WorkCity && (
                                <FormFeedback>
                                  {formik.errors.WorkCity}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="">
                              Where Did You Hear About Us?
                            </Label>

                            <Input
                              type="text"
                              name="SourceName"
                              id="nameVertical"
                              placeholder="Enter source name"
                              onChange={formik.handleChange}
                              value={formik.values.SourceName}
                              invalid={
                                formik.touched.SourceName &&
                                !!formik.errors.SourceName
                              }
                            />
                            {formik.touched.SourceName &&
                              formik.errors.SourceName && (
                                <FormFeedback>
                                  {formik.errors.SourceName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="headingStyle my-3 ml-4">Present Address</p>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm="12">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Address
                              <span className="mandatory">*</span>
                            </Label>
                            <Input
                              type="textarea"
                              className="p-3"
                              name="AuditorAddress"
                              placeholder="Enter your address"
                              // id="nameVertical"
                              onChange={formik.handleChange}
                              value={formik.values.AuditorAddress}
                              invalid={
                                formik.touched.AuditorAddress &&
                                !!formik.errors.AuditorAddress
                              }
                              maxLength={400}
                            />
                            {/* <div
                              className="text-end text-muted mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {formik.values.AuditorAddress?.length}/400
                            </div> */}
                            {formik.touched.AuditorAddress &&
                              formik.errors.AuditorAddress && (
                                <FormFeedback>
                                  {formik.errors.AuditorAddress}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6" style={{ zIndex: "5" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              Country<span className="mandatory">*</span>
                            </Label>
                            <Select
                              className={`React ${
                                formik.touched.AuditorCountry &&
                                formik.errors.AuditorCountry
                                  ? "is-invalid"
                                  : ""
                              }`}
                              classNamePrefix="select"
                              name="AuditorCountry"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "AuditorCountry",
                                  selectedOption
                                );
                                formik.setFieldValue("AuditorState", "");
                                formik.setFieldValue("AuditorCity", "");
                              }}
                              options={allCountry}
                              value={formik.values.AuditorCountry}
                              styles={generateCustomStyles(
                                "AuditorCountry",
                                formik
                              )}
                            />
                            {formik.touched.AuditorCountry &&
                              formik.errors.AuditorCountry && (
                                <FormFeedback>
                                  {formik.errors.AuditorCountry.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6" style={{ zIndex: "4" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              State<span className="mandatory">*</span>
                            </Label>
                            <Select
                              className={`React ${
                                formik.touched.AuditorState &&
                                formik.errors.AuditorState
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={generateCustomStyles(
                                "AuditorState",
                                formik
                              )}
                              classNamePrefix="select"
                              name="AuditorState"
                              onChange={(selectedOption) => {
                                formik.setFieldValue(
                                  "AuditorState",
                                  selectedOption
                                );
                              }}
                              value={formik.values.AuditorState}
                              options={allState}
                            />
                            {formik.touched.AuditorState &&
                              formik.errors.AuditorState && (
                                <FormFeedback>
                                  {formik.errors.AuditorState.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6" style={{ zIndex: "3" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              City<span className="mandatory">*</span>
                            </Label>
                            <Select
                              className={`React ${
                                formik.touched.AuditorCity &&
                                formik.errors.AuditorCity
                                  ? "is-invalid"
                                  : ""
                              }`}
                              classNamePrefix="select"
                              name="AuditorCity"
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AuditorCity",
                                  selectedOption
                                )
                              }
                              options={allCity}
                              styles={generateCustomStyles(
                                "AuditorCity",
                                formik
                              )}
                              value={formik.values.AuditorCity}
                            />
                            {formik.touched.AuditorCity &&
                              formik.errors.AuditorCity && (
                                <FormFeedback className="d-block">
                                  {formik.errors.AuditorCity.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="AuditorPincode">
                              Pincode<span className="mandatory">*</span>
                            </Label>
                            <Input
                              min={0}
                              type="number" // Use type="text" for better control
                              name="AuditorPincode"
                              id="nameVertical"
                              placeholder="Enter your Pincode"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.AuditorPincode}
                              invalid={
                                formik.touched.AuditorPincode &&
                                !!formik.errors.AuditorPincode
                              }
                              className="input-no-spinner"
                            />
                            {formik.touched.AuditorPincode &&
                              formik.errors.AuditorPincode && (
                                <FormFeedback>
                                  {formik.errors.AuditorPincode}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="headingStyle my-3 ml-4">
                    Qualification & Experience
                  </p>
                  <CardBody>
                    <div>
                      <Row>
                        <Col sm="6" style={{ zIndex: "2" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              Qualification<span className="mandatory">*</span>
                            </Label>
                            <Select
                              className={`React ${
                                formik.touched.AuditorQual &&
                                formik.errors.AuditorQual
                                  ? "is-invalid"
                                  : ""
                              }`}
                              classNamePrefix="select"
                              name="AuditorQual"
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AuditorQual",
                                  selectedOption
                                )
                              }
                              value={formik.values.AuditorQual}
                              options={Allqualification}
                              styles={generateCustomStyles(
                                "AuditorQual",
                                formik
                              )}
                            />
                            {formik.touched.AuditorQual &&
                              formik.errors.AuditorQual && (
                                <FormFeedback>
                                  {formik.errors.AuditorQual.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Qualification Certificate{" "}
                              {formik?.values?.qualProofFile ? (
                                <a
                                  href={formik?.values?.qualProofFile}
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                "(.pdf file)"
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="qualProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              className={`React ${
                                formik.touched.qualProofFile &&
                                formik.errors.qualProofFile
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={generateCustomStyles(
                                "qualProofFile",
                                formik
                              )}
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                formik.setFieldValue("qualProofFile", file);
                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />
                            {formik.touched.qualProofFile &&
                              formik.errors.qualProofFile && (
                                <FormFeedback>
                                  {formik.errors.qualProofFile}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="">
                              Experience<span className="mandatory">*</span>
                            </Label>
                            <Input
                              min={0}
                              type="number"
                              name="TotalExperience"
                              id="nameVertical"
                              placeholder="Enter your Total Experience"
                              onChange={formik.handleChange}
                              value={formik.values.TotalExperience}
                              invalid={
                                formik.touched.TotalExperience &&
                                !!formik.errors.TotalExperience
                              }
                            />
                            {formik.touched.TotalExperience &&
                              formik.errors.TotalExperience && (
                                <FormFeedback>
                                  {formik.errors.TotalExperience}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="3">
                          <div className="text-center">
                            <Label htmlFor="nameVertical">
                              Experience with TRPW ?
                            </Label>
                            <div className="d-flex justify-content-center my-2">
                              <div className="mr-5">
                                <Input
                                  type="radio"
                                  name="ExperienceTrpw"
                                  onChange={() =>
                                    formik.setFieldValue("ExperienceTrpw", 1)
                                  }
                                  style={{ accentColor: "#c16d18" }}
                                  checked={formik.values.ExperienceTrpw == 1}
                                  value={formik.values.ExperienceTrpw}
                                />
                                <span>Yes</span>
                              </div>
                              <div className="d-flex ">
                                {" "}
                                <Input
                                  type="radio"
                                  name="ExperienceTrpw"
                                  onChange={() =>
                                    formik.setFieldValue("ExperienceTrpw", 0)
                                  }
                                  style={{ accentColor: "#c16d18" }}
                                  checked={formik.values.ExperienceTrpw == 0}
                                  value={formik.values.ExperienceTrpw}
                                />
                                <span>No</span>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col sm="5">
                          <FormGroup>
                            <Label htmlFor="">
                              Name of the Manager / Employee ID
                            </Label>
                            <Input
                              type="text"
                              name="PreEmployeeName"
                              id="nameVertical"
                              placeholder="Name / Employee ID"
                              onChange={formik.handleChange}
                              value={formik.values.PreEmployeeName}
                              disabled={formik.values.ExperienceTrpw == 0}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Work Experiences
                              <span className="mandatory"></span>
                            </Label>
                            <Input
                              type="textarea"
                              name="WorkExperience"
                              id="nameVertical"
                              style={{ height: "10em" }}
                              className="pt-2"
                              placeholder="Brief your previous Work Experiences"
                              onChange={formik.handleChange}
                              value={formik.values.WorkExperience}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  id="jobCard"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="headingStyle my-3 ml-4">Verification</p>
                  <CardBody>
                    <div>
                      <Row>
                        {/* <Col sm="4" style={{zIndex:'3'}}>
                        <FormGroup>
                          <Label htmlFor="">
                            Identity Proof<span className="mandatory">*</span>
                          </Label>
                          <Select
                            className={`React ${
                              formik.touched.IDProof && formik.errors.IDProof
                                ? "is-invalid"
                                : ""
                            }`}
                            classNamePrefix="select"
                            name="IDProof"
                            options={idProof}
                            styles={generateCustomStyles("IDProof", formik)}
                            onChange={(selectedOption) =>
                              formik.setFieldValue("IDProof", selectedOption)
                            }
                            value={formik.values.IDProof}
                          />
                          {formik.touched.IDProof && formik.errors.IDProof && (
                            <FormFeedback>
                              {formik.errors.IDProof.value}
                            </FormFeedback>
                          )}
                        </FormGroup>
                      </Col> */}

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              PAN Number<span className="mandatory">*</span>
                            </Label>
                            <Input
                              type="text"
                              name="IdProofNumber"
                              id="nameVertical"
                              placeholder="ID Number"
                              
                              // onChange={formik.handleChange}
                              onChange={(e) => {
                                const uppercaseValue = e.target.value.toUpperCase();
                                formik.setFieldValue("IdProofNumber", uppercaseValue);
                              }}
                              value={formik.values.IdProofNumber}
                              invalid={
                                formik.touched.IdProofNumber &&
                                !!formik.errors.IdProofNumber
                              }
                            />
                            {formik.touched.IdProofNumber &&
                              formik.errors.IdProofNumber && (
                                <FormFeedback>
                                  {formik.errors.IdProofNumber}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="">
                              Name as per PAN{" "}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <Input
                              type="text"
                              name="PanHolderName"
                              id="nameVertical"
                              placeholder="Enter your Name"
                              style={{ textTransform: "capitalize" }}
                              onChange={formik.handleChange}
                              value={formik.values.PanHolderName}
                              invalid={
                                formik.touched.PanHolderName &&
                                !!formik.errors.PanHolderName
                              }
                            />
                            {formik.touched.PanHolderName &&
                              formik.errors.PanHolderName && (
                                <FormFeedback>
                                  {formik.errors.PanHolderName}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              PAN Proof{" "}
                              {formik?.values?.identityProofFile ? (
                                <a
                                  href={formik?.values?.identityProofFile}
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                "(.pdf file)"
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="identityProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              className={`React ${
                                formik.touched.identityProofFile &&
                                formik.errors.identityProofFile
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={generateCustomStyles(
                                "identityProofFile",
                                formik
                              )}
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                formik.setFieldValue("identityProofFile", file);
                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />
                            {formik.touched.identityProofFile &&
                              formik.errors.identityProofFile && (
                                <FormFeedback>
                                  {formik.errors.identityProofFile}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4" style={{ zIndex: "2" }}>
                          <FormGroup>
                            <Label htmlFor="">
                              {" "}
                              Address Proof<span className="mandatory">*</span>
                            </Label>
                            <Select
                              className={`React ${
                                formik.touched.AddressProof &&
                                formik.errors.AddressProof
                                  ? "is-invalid"
                                  : ""
                              }`}
                              classNamePrefix="select"
                              name="AddressProof"
                              options={addressProof}
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "AddressProof",
                                  selectedOption
                                )
                              }
                              styles={generateCustomStyles(
                                "AddressProof",
                                formik
                              )}
                              value={formik.values.AddressProof}
                            />
                            {formik.touched.AddressProof &&
                              formik.errors.AddressProof && (
                                <FormFeedback>
                                  {formik.errors.AddressProof.value}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="AddressProofNumber">
                              Document Number
                              <span className="mandatory">*</span>
                            </Label>
                            <Input
                              // style={{borderRadius:'4px'}}
                              type="text"
                              name="AddressProofNumber"
                              id="AddressProofNumber"
                              placeholder="ID Number"
                              onChange={formik.handleChange}
                              value={formik.values.AddressProofNumber.toUpperCase()}
                              invalid={
                                formik.touched.AddressProofNumber &&
                                !!formik.errors.AddressProofNumber
                              }
                            />
                            {formik.touched.AddressProofNumber &&
                              formik.errors.AddressProofNumber && (
                                <FormFeedback>
                                  {formik.errors.AddressProofNumber}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>

                        <Col sm="4">
                          <FormGroup>
                            <Label htmlFor="nameVertical">
                              Document Proof{" "}
                              {formik?.values?.AddressProofFile ? (
                                <a
                                  href={formik?.values?.AddressProofFile}
                                  target="__blank"
                                  className="ml-2 text-primary"
                                >
                                  ( View )
                                </a>
                              ) : (
                                "(.pdf file)"
                              )}
                              <span className="mandatory cursor-pointer">
                                *
                              </span>
                            </Label>

                            <CustomInput
                              type="file"
                              name="AddressProofFile"
                              accept="application/pdf"
                              id="nameVertical"
                              className={`React ${
                                formik.touched.AddressProofFile &&
                                formik.errors.AddressProofFile
                                  ? "is-invalid"
                                  : ""
                              }`}
                              styles={generateCustomStyles(
                                "AddressProofFile",
                                formik
                              )}
                              onChange={(e) => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                formik.setFieldValue("AddressProofFile", file);
                                if (file && file.size > 5000000) {
                                  Notiflix.Notify.failure(
                                    "File too large, upload file less than 5 Mb."
                                  );
                                }
                              }}
                            />
                            {formik.touched.AddressProofFile &&
                              formik.errors.AddressProofFile && (
                                <FormFeedback>
                                  {formik.errors.AddressProofFile}
                                </FormFeedback>
                              )}
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <p className="mt-3 ml-4 headingStyle">Resume</p>

                  <CardBody>
                    <Row>
                      <Col sm="4">
                        <FormGroup>
                          <Label htmlFor="nameVertical">
                            Upload Resume
                            {formik?.values?.resumeFile ? (
                              <a
                                href={formik?.values?.resumeFile}
                                target="__blank"
                                className="ml-2 text-primary"
                              >
                                ( View )
                              </a>
                            ) : (
                              "(.pdf file)"
                            )}
                          </Label>

                          <CustomInput
                            type="file"
                            name="resumeFile"
                            accept="application/pdf"
                            id="nameVertical"
                            onChange={(e) => {
                              e.preventDefault();
                              const file = e.target.files[0];
                              formik.setFieldValue("resumeFile", file);
                              if (file && file.size > 5000000) {
                                Notiflix.Notify.failure(
                                  "File too large, upload file less than 5 Mb."
                                );
                              }
                            }}
                          />
                          {formik.touched.resumeFile &&
                            formik.errors.resumeFile && (
                              <div className="error text-danger pl-2">
                                {formik.errors.resumeFile}
                              </div>
                            )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card
                  className="mt-3 border-0"
                  style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
                >
                  <CardBody>
                    <Row>
                      <Col sm="12" className="mb-4">
                        <Label>
                          <span style={{ fontWeight: "bolder" }}>Note : </span>
                          All fields marked with ({" "}
                          <span className="mandatory">*</span> ) are mandatory.
                        </Label>
                      </Col>
                    </Row>
                    <div className="text-right">
                      <button
                        className="cancelBtn mr-2"
                        onClick={() => history.push("/auditor-list")}
                      >
                        Cancel{" "}
                      </button>
                      <button
                        className="btns"
                        // className=" btn btn-common"
                        onClick={submitHandler}
                      >
                        Submit{" "}
                      </button>
                    </div>
                  </CardBody>
                </Card>
              </FormGroup>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuditorJobPage;
